module.exports = __webpack_public_path__ + "img/error_white.8c5d5bb8.png";